import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import poiTag from './poiTag.vue';
import { reportActionToRedies, goThirdApp } from '../utils';
import { truncateString, addPvNew, isBaiduMap, isBaiduMapAuto, getFloatWebUrl, isHarmony } from '../../../utils';
import { openUrlByOpenApi } from '@baidu/map-fe-utils';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    poiTag
  },
  props: {
    feedItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // poi数组
    poiList: {
      type: Array,
      default: () => []
    },
    dataIndex: {
      type: Number,
      default: 0
    },
    unique_id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      poiShowList: [],
      isBaiduMap: isBaiduMap(),
      isBaiduMapAuto: isBaiduMapAuto(),
      isHarmony: isHarmony()
    };
  },
  watch: {
    // 有预加载时，取最后更新的poi最新数据，用于后续处理。todo：预加载逻辑删除时，可以把此处删除，直接取poiList
    poiList: {
      deep: true,
      immediate: true,
      handler(val) {
        this.poiShowList = val;
        this.$nextTick(() => {
          this.poiNum > 1 && this.resetPoiList();
        });
      }
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['phoneInfo', 'is_dark'])), mapGetters('url', ['urlParams', 'source'])), {}, {
    // 是否展示跳转第三方更多tag
    showMoreTag() {
      return !this.isBaiduMapAuto && this.isBaiduMap && this.hiddenComment && !this.isHarmony;
    },
    // 跳转第三方更多tag事件
    visiblePoiLine() {
      const {
        isBaiduMapAuto,
        poiNum
      } = this;
      return poiNum && !isBaiduMapAuto;
    },
    poiNum() {
      return this.poiList.length;
    },
    poiString() {
      return poiItem => {
        return truncateString(poiItem.name, 15);
      };
    },
    poiNumString() {
      return `共${this.poiNum}个地点`;
    },
    // 评论类型无跳转链接隐藏资源位
    hiddenComment() {
      const {
        detail_url: commentNoteUrl = '',
        message = '',
        tpl_type = ''
      } = this.feedItem.guide || {};
      const noCommentBtn = tpl_type === 'comment' && commentNoteUrl === '';
      // 笔记类型无跳转链接隐藏资源位
      const noFeedBtn = tpl_type !== 'comment' && message === '';
      return !(noCommentBtn || noFeedBtn);
    }
  }),
  mounted() {
    this.showHandle();
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    updateReqParams: 'dataList/updateReqParams'
  })), {}, {
    /**
     * 重置可以显示的tag信息
     */
    resetPoiList() {
      var _this$$refs$numTag, _this$$refs;
      // 屏幕宽度
      const totalWidth = this.$refs.poiLine.offsetWidth;
      // 最后一个表示数量的tag的宽度
      const numTagWidth = (_this$$refs$numTag = this.$refs.numTag) === null || _this$$refs$numTag === void 0 || (_this$$refs$numTag = _this$$refs$numTag.$el) === null || _this$$refs$numTag === void 0 ? void 0 : _this$$refs$numTag.offsetWidth;
      // 连锁tag的宽度
      const chainWidth = ((_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.chain) === null || _this$$refs === void 0 ? void 0 : _this$$refs.offsetWidth) || 0;
      // 16-左margin；10-右margin；5-buffer
      let contentWidth = 16 + 10 + 5 + numTagWidth + chainWidth;
      let tagIndex = 0;
      for (let i = 0; i < this.poiShowList.length; i++) {
        var _this$$refs$refStr$;
        const refStr = 'tag' + i;
        // 循环展示的tag的宽度，与最后一个的宽度累加，找到最后一个可以显示的tag
        contentWidth += (_this$$refs$refStr$ = this.$refs[refStr][0]) === null || _this$$refs$refStr$ === void 0 || (_this$$refs$refStr$ = _this$$refs$refStr$.$el) === null || _this$$refs$refStr$ === void 0 ? void 0 : _this$$refs$refStr$.offsetWidth;
        // 6-tag的右margin
        contentWidth += 6;
        if (contentWidth > totalWidth) {
          tagIndex = i;
          this.poiShowList = this.poiShowList.slice(0, tagIndex);
          return;
        }
      }
    },
    poiClick(poiObj) {
      const {
        type = '',
        index = 0
      } = poiObj || {};
      const {
        unique_id,
        source,
        phoneInfo
      } = this;
      // 上报action
      reportActionToRedies({
        unique_id
      }, index, 'click_poi', phoneInfo);
      if (type !== 'more-poi' && !this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      if (type === 'more-poi') {
        //  展开poi列表
        this.openPoiList(unique_id);
        addPvNew(['NewMedia.detailspage.poidrawerpoi.click'], {
          type: 'image',
          note_style: 'Micro',
          poi_action: 'more',
          unique_id,
          source
        });
      } else {
        const {
          bury: {
            stdTag = '',
            levelOne = '',
            levelTwo = ''
          } = {}
        } = poiObj || {};
        addPvNew(['NewMedia.detailspage.poidrawerpoi.click'], {
          type: 'image',
          note_style: 'Micro',
          poi_action: 'poi',
          std_tag: stdTag,
          levelOne,
          levelTwo,
          unique_id,
          source
        });
        openUrlByOpenApi(poiObj.detailUrl);
        // 更新请求参数
        this.updateReqParams(this.feedItem);
      }
    },
    openPoiList(unique_id) {
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      if (isBaiduMap()) {
        const hostname = getFloatWebUrl();
        const url = encodeURIComponent(`https://${hostname}/feed-h5/micro-detail-panel/?showPoiList=1&unique_id=${unique_id}`);
        window.location.href = `baidumap://map/floatweb?action=open&popRoot=no&attachToPage=true&popStyle=1&url=${url}`;
      }
    },
    // 去第三方app查看更多
    poiMoreClick() {
      const {
        feedItem: {
          tpl_type = 'feed',
          guide = {},
          actionBar = {}
        } = {}
      } = this;
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      if (tpl_type === 'comment') {
        // 评论类型上报埋点，并跳转第三方app查看更多评论列表
        const {
          author: {
            tpSource = ''
          }
        } = actionBar || {};
        addPvNew(['POl.comment_list.type.click'], {
          tp_from: tpSource
        });
        this.commentMoreClick(tpl_type);
        return;
      }
      if (tpl_type !== 'comment') {
        // 埋点
        addPvNew(['NewMedia.detailspagediaoqi.click'], {
          source: this.source
        });
        const {
          tpSource = '',
          more: {
            detailUrl = '',
            fallbackUrl = '',
            directJump = false
          } = {}
        } = guide || {};
        // 是否直接跳转其他app
        let jumpParam = {};
        if (directJump) {
          jumpParam = {
            scheme: detailUrl,
            fallbackUrl,
            pvHead: ['NewMedia.detailspage.callup.success.click'],
            // 跳转成功埋点
            pvParam: {
              type: tpSource,
              callup_type: 1
            },
            // 跳转失败埋点
            failPvParam: {
              type: tpSource,
              callup_type: 2
            },
            isAddSuccAndFail: true
          };
        }
        goThirdApp({
          jumpParam,
          directJump,
          detailUrl,
          fallbackUrl,
          feedType: tpl_type
        });
      }
    },
    // 评论转笔记跳转到第三方app
    commentMoreClick(feedType) {
      const {
        guide: {
          detail_url: detailUrl = '',
          fallback_url: fallbackUrl = ''
        }
      } = this.feedItem || {};
      // 评论转笔记用户头像点击：百度用户无反应，tp用户跳到小程序评论列表
      if (!detailUrl) {
        return;
      }
      const jumpParam = {
        scheme: detailUrl,
        fallbackUrl,
        pvHead: ['NewMedia.detailspage.callup.success.click'],
        isAddSuccAndFail: true
      };
      goThirdApp({
        jumpParam,
        directJump: true,
        detailUrl,
        fallbackUrl,
        feedType
      });
    },
    showHandle() {
      const {
        reqType = ''
      } = this.urlParams || {};
      if (!this.showMoreTag && reqType !== 'poicomment') {
        return;
      }
      const {
        author: {
          tpSource = ''
        }
      } = this.feedItem.actionBar || {};
      this.$nextTick(() => {
        const commentRef = this.$refs.poiLine;
        commentRef && this.$io.observe(commentRef, () => {
          addPvNew(['POl.comment_list.type.show'], {
            tp_from: tpSource
          });
        });
      });
    }
  })
};